import type { OrientationParams } from '@/core/document/types'

export function summarizeOrientation(params: OrientationParams): string {
  const fragments: string[] = []
  if (params.quarterTurns !== 0) fragments.push(`↻${params.quarterTurns * 90}°`)
  if (params.flipHorizontal || params.flipVertical) fragments.push('⇋')
  if (params.straightenDeg !== 0) fragments.push(`${params.straightenDeg.toFixed(1)}°`)
  return fragments.join(' · ')
}
